import { h, Fragment } from "preact";
import { translate, t } from "../../I18n";
function CartItemDescription(props) {
    const { text, url } = props;
    const hasUrl = !!url;
    return (h("p", { class: "description" },
        text,
        hasUrl && (h(Fragment, null,
            " ",
            h("a", { href: url, target: "_blank" }, translate(t.cart.promotions.showMore))))));
}
export default CartItemDescription;
